/**
 * Available navigation apps for iOS
 */
export var IOSNavigationApp;
(function (IOSNavigationApp) {
    IOSNavigationApp["APPLE_MAPS"] = "apple_maps";
    IOSNavigationApp["GOOGLE_MAPS"] = "google_maps";
    IOSNavigationApp["WAZE"] = "waze";
    IOSNavigationApp["CITYMAPPER"] = "citymapper";
    IOSNavigationApp["NAVIGON"] = "navigon";
    IOSNavigationApp["GARMIN_NAVIGON"] = "navigon";
    IOSNavigationApp["TRANSIT_APP"] = "transit_app";
    IOSNavigationApp["YANDEX_NAVIGATOR"] = "yandex";
    IOSNavigationApp["UBER"] = "uber";
    IOSNavigationApp["TOMTOM"] = "tomtom";
    IOSNavigationApp["SYGIC"] = "sygic";
    IOSNavigationApp["HERE_MAPS"] = "here_maps";
    IOSNavigationApp["MOOVIT"] = "moovit";
    IOSNavigationApp["LYFT"] = "lyft";
    IOSNavigationApp["MAPS_ME"] = "maps_me";
    IOSNavigationApp["GURU_MAPS"] = "guru_maps";
    IOSNavigationApp["ORGANIC_MAPS"] = "organic_maps";
    IOSNavigationApp["YANDEX_MAPS"] = "yandex_maps";
    IOSNavigationApp["TWO_GIS"] = "2gis";
    IOSNavigationApp["CABIFY"] = "cabify";
    IOSNavigationApp["BAIDU"] = "baidu";
    IOSNavigationApp["GAODE"] = "gaode";
    IOSNavigationApp["TESLA"] = "tesla";
    IOSNavigationApp["TAXIS_99"] = "taxis_99";
    IOSNavigationApp["TAXI_99"] = "taxis_99";
})(IOSNavigationApp || (IOSNavigationApp = {}));
/**
 * Available navigation apps for Android
 */
export var AndroidNavigationApp;
(function (AndroidNavigationApp) {
    AndroidNavigationApp["GEO"] = "geo";
    AndroidNavigationApp["GOOGLE_MAPS"] = "google_maps";
    AndroidNavigationApp["WAZE"] = "waze";
    AndroidNavigationApp["CITYMAPPER"] = "citymapper";
    AndroidNavigationApp["UBER"] = "uber";
    AndroidNavigationApp["YANDEX"] = "yandex";
    AndroidNavigationApp["SYGIC"] = "sygic";
    AndroidNavigationApp["HERE_MAPS"] = "here_maps";
    AndroidNavigationApp["MOOVIT"] = "moovit";
    AndroidNavigationApp["LYFT"] = "lyft";
    AndroidNavigationApp["MAPS_ME"] = "maps_me";
    AndroidNavigationApp["TOMTOM"] = "tomtom";
    AndroidNavigationApp["GURU_MAPS"] = "guru_maps";
    AndroidNavigationApp["ORGANIC_MAPS"] = "organic_maps";
    AndroidNavigationApp["YANDEX_MAPS"] = "yandex_maps";
    AndroidNavigationApp["MAPY"] = "mapy";
    AndroidNavigationApp["TWO_GIS"] = "2gis";
    AndroidNavigationApp["CABIFY"] = "cabify";
    AndroidNavigationApp["BAIDU"] = "baidu";
    AndroidNavigationApp["GAODE"] = "gaode";
    AndroidNavigationApp["TAXIS_99"] = "taxis_99";
    AndroidNavigationApp["TAXI_99"] = "taxis_99";
    AndroidNavigationApp["TESLA"] = "tesla";
})(AndroidNavigationApp || (AndroidNavigationApp = {}));
/**
 * Transport modes
 */
export var TransportMode;
(function (TransportMode) {
    TransportMode["DRIVING"] = "driving";
    TransportMode["WALKING"] = "walking";
    TransportMode["BICYCLING"] = "bicycling";
    TransportMode["TRANSIT"] = "transit";
})(TransportMode || (TransportMode = {}));
/**
 * Launch modes
 */
export var LaunchMode;
(function (LaunchMode) {
    LaunchMode["MAPS"] = "maps";
    LaunchMode["TURN_BY_TURN"] = "turn_by_turn";
    LaunchMode["GEO"] = "geo";
})(LaunchMode || (LaunchMode = {}));
//# sourceMappingURL=definitions.js.map